#import "@core/schema/fragments/ApplicationFull.graphql"

mutation (
  $input: CreateApplicationInput!
  $locale: Locale!
) {
  sendApplication(
    input: $input
    locale: $locale
  ) {
    ...ApplicationFull
  }
}
